const values = [
  {
    icon: 'ri-stack-line',
    title: 'Clean Architecture',
    description:
      'Systems designed with separation of concerns, modularity, and testability at their core. Every component has a clear purpose and well-defined boundaries, enabling teams to iterate quickly without accumulating technical debt.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Performance Optimization',
    description:
      'Deep focus on runtime efficiency, memory management, and responsive interactions. We profile, measure, and refine every critical path to deliver experiences that feel instantaneous and remain smooth under real-world conditions.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'User-Centered Design',
    description:
      'Engineering decisions driven by how people actually interact with software. Accessibility, intuitive navigation, and thoughtful interface patterns are not afterthoughts but foundational principles in every project we undertake.',
  },
];

export default function Values() {
  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <p className="font-label text-xs font-medium text-foreground-500 tracking-widest uppercase mb-3">
            Engineering principles
          </p>
          <h3 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.12] tracking-tight">
            How we approach
            <br />
            every project
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {values.map((value) => (
            <div
              key={value.title}
              className="bg-background-50 rounded-2xl p-6 md:p-8 flex flex-col gap-5"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-secondary-100">
                <i className={`${value.icon} text-xl text-secondary-700`}></i>
              </div>
              <h4 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                {value.title}
              </h4>
              <p className="font-body text-sm md:text-base text-foreground-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}